import { render, staticRenderFns } from "./approvalProcess.vue?vue&type=template&id=5d0c41d4"
import script from "./approvalProcess.vue?vue&type=script&lang=js"
export * from "./approvalProcess.vue?vue&type=script&lang=js"
import style0 from "./approvalProcess.vue?vue&type=style&index=0&id=5d0c41d4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports